/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CardsavrHelper } from "@strivve/strivve-sdk/lib/cardsavr/CardsavrHelper";
import { MerchantSite } from "@/helpers/types";
import CardsavrRestError from "@strivve/strivve-sdk/lib/cardsavr/CardsavrRestError";
import CardsavrSDKError from "@strivve/strivve-sdk/lib/cardsavr/CardsavrSDKError";
import { useRouter } from 'next/router';

export class CardupdatrHelper extends CardsavrHelper {

    private static _instance: CardupdatrHelper;

    public static getInstance(): CardupdatrHelper {
        if (!CardupdatrHelper._instance) {
            CardupdatrHelper._instance = new CardupdatrHelper();
        }
        return CardupdatrHelper._instance;
    }

    public async check_card_for_missing_fields(card_id : string, cardholder_id : string, agent_username : string, sites : MerchantSite[]): Promise<unknown> {
        const agent_session = this.getSession(agent_username);
        const site_ids = sites.map(site => String(site.id)).join(",");
        const req_fields =  await agent_session.sendRequest(`/cardholders/required_fields?id=${cardholder_id}&card_id=${card_id}&merchant_site_ids=${site_ids}`, "get");
        return req_fields.body;
    }

    public async create_cardholder(agent_username: string, financial_institution: string, cardholder_data: any, source : any): Promise<unknown> {
        //don't need the login data
        const cardholder_data_copy = { ...cardholder_data };
        cardholder_data_copy.role = "cardholder";

        const agent_session = super.getSession(agent_username);
        const cardholder_response = await agent_session.createCardholder(cardholder_data_copy, null, financial_institution, {"x-cardsavr-hydration" : JSON.stringify(["grant"])});
        if (cardholder_response.body.grant) {
            await agent_session.authorizeCardholder(cardholder_response.body.grant, source);
        }
        return cardholder_response.body;
    }

    public async get_single_site_job(job_id: any, agent_username: string) : Promise<any|boolean> {
        const agent_session = super.getSession(agent_username);
        if(agent_session) {
            const job = await agent_session.getSingleSiteJobs(job_id, {}, {"x-cardsavr-hydration": JSON.stringify(["account"])});
            if(job.body) {
                return job.body;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public async submit_user_job(username, cardholder_id, selected_site, CardupdatrHelper, card_id = undefined, queueNameOverride, type_override, proxyPriorityOverride, cardholder_cuid, safe_key, vbs_config) {
        const job_data = {
            account : { merchant_site_id : selected_site.id, customer_key : `${selected_site.id}$${cardholder_cuid}`},
            status : selected_site.quick_start ? "REQUESTED" : "INITIATED",
            card_id,
            cardholder_id,
            queue_name_override : queueNameOverride ?? selected_site.queue_name,
            type_override, 
            proxy_priority_override : proxyPriorityOverride,
            vbs_config : vbs_config
        }

        const ch = CardupdatrHelper.getInstance();

        const response = await ch.placeCardOnSites({username, jobs_data : [job_data], safe_key});
        return response.body[0];
    }

    public async refresh_user_session(username) {
        const session = this.getSession(username);
        return await session.refresh();
    }


    public async get_merchant_sites(username, top_hosts, merchant_sites_tag_array, exclude_hosts) {
        const session = this.getSession(username);
        const filters = { tags : merchant_sites_tag_array, image_widths : "128,32", top_hosts, exclude_hosts };
        // TODO: Need to add pagination support. SiteTileContainer will need relatively large refactoring to support this.
        const sites_response = await session.getSites(filters, { page : 1, page_length : 9999, sort : "name", is_descending : false });
        const merchant_sites = sites_response.body;
        return merchant_sites;
    }

    public async get_fi(username, lookup_key) {
        const filters = { lookup_key };
        const fis_response = await this.getSession(username).getFinancialInstitutions(filters);
        const fi = fis_response.body;
        return fi;
    }
}
